import SummarizeIcon from '@mui/icons-material/Summarize';
import { Avatar, Box, Grid, IconButton, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KPeeLogo from '../LogoKPee1.png';
import { api } from '../api';
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from '../auth/Token';
import { useMode } from "../theme";

export const PrintApplicationForms = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const location = useLocation();
    const association_id = location.state && location.state.association_id;
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [members, setMembers] = useState([])
    const [details, setDetails] = useState([])

    const fetchData = () => {
        api.get(`/association/association/application/forms/print/${association_id}`, {
          headers: {
              Authorization: 'Bearer '+fetchToken()
          },
        }).then(function (response){
            setMembers(response.data?.members)
            setDetails(response.data?.details)
        }).catch(function (error){
          console.log(error)
        });
    }

    useEffect(() => {
        fetchData();
    },[])


    const columns = [
        {
            field: "member_id",
            headerName: "ID",
            flex:1,
        },
        {
            field: "passbook_id",
            headerName: "Passbook Id",
            flex: 1,
            renderCell:params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.passbook_id}</b>
                </Typography>
        },
        {
            field: "Fullname",
            headerName: 'Member Name',
            flex: 1,
            renderCell:params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.firstname} {params.row.middlename?params.row.middlename:''} {params.row.lastname?params.row.lastname:''}</b>
                </Typography>
        },
        {
          field: "phone",
          headerName: "Contact Number",
          flex: 1,
          renderCell: params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.phone}</b>
                </Typography>
        },
        {
            field: "firstname",
            headerName: "First Name",
            flex: 1,
            renderCell: params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.firstname}</b>
                </Typography>
        },
        {
          field: "middlename",
          headerName: "Middle Name",
          flex: 1,
          renderCell: params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.middlename}</b>
                </Typography>
        },
        {
            field: "lastname",
            headerName: 'Last Name',
            flex: 1,
            renderCell: params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.lastname}</b>
                </Typography>
        },
        {
            field: "request_amount",
            headerName: 'Request Amount',
            flex: 1,
        },
        {
            field: "sign",
            headerName: 'Sign/Thumb Print',
            flex: 1,
            renderCell: params => <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>{params.row.sign}</b>
                </Typography>
        },
    ]
  

    const printRef = React.useRef();

    const handlePrint = async () => {
        const element = printRef.current;
        const canvas = await html2canvas(element);
        const data = canvas.toDataURL('image/png');
    
        const pdf = new jsPDF();
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    
        const pageHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginTop = 10;
        const marginRight = 10;
        const marginBottom = 10;
        let yOffset = 0;
        let pageNumber = 1;
    
        while (yOffset < pdfHeight) {
            if (pageNumber > 1) {
                pdf.addPage();
            }
    
            pdf.addImage(
                data,
                'PNG',
                marginLeft,
                marginTop - yOffset,
                pdfWidth - marginLeft - marginRight,
                pdfHeight - marginTop - marginBottom
            );
    
            // Add page label
            pdf.setFontSize(8);  // Make the font size smaller
        pdf.text(`Page ${pageNumber}`, marginLeft - 9, pageHeight - marginBottom + 5);
    
            yOffset += pageHeight - marginTop - marginBottom;
            pageNumber++;
        }
    
        pdf.save('ApplicationForm.pdf');
    };

  return (
      <div className="app">
        <main className="content">
            <Box>
                <Box sx={{ display:'flex', m:1 }}>
                        <Typography sx={{ ml:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Print:</b>
                            <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                        </Typography>
                    </Box>
                    <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                        <Box sx={{ m:1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', color:'grey',mb:3 }}><b>~ The Cooperative ~</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Avatar src={KPeeLogo} alt='KPee logo' sx={{ width:120, height:120, m:'auto' }} />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.society}</b></Typography>
                                    <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.community_name} Community</b></Typography>
                                    <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.cluster_name} Cluster</b></Typography>
                                    <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.association_name} Savings Group</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>Application Forms</b></Typography>
                                </Grid>


                                <Grid item xs={12} md={12} sx={{ mb:5 }}>
                                    <DataGrid
                                        rows={members}
                                        columns={columns}
                                        autoHeight
                                        rowHeight={130}
                                        getRowId={(row) => row.passbook_id}
                                        slots={{ toolbar: GridToolbar }}
                                        initialState={{
                                            columns: {
                                                columnVisibilityModel: {
                                                    firstname: false,
                                                    middlename: false,
                                                    lastname: false,
                                                    member_id:false,
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                
                            </Grid>

                        </Box>
                    </div>
                </Box>
                </main>
      </div>
  )
}
